import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import ApproveUser from './ApproveUser';
import ListUserItem from './ListUserItem';
import { type User } from '../../../common/types';

interface IProps {
  items: User[];
  filter?: { pending: boolean };
  toggleEditModal: () => any;
  toggleDeleteModal: () => any;
  handleEditingItem: (item: User) => any;
  handleDeletingItem: (item: User) => any;
}

interface ActionItem {
  label: string;
  icon: JSX.Element | '';
  type: 'button' | 'link' | 'component';
  link?: string;
  handler?: () => any;
}

const ListUsers: React.FC<IProps> = ({
  items: users,
  filter,
  toggleEditModal,
  toggleDeleteModal,
  handleEditingItem,
  handleDeletingItem
}) => {
  const editItemHandler = (item: User): void => {
    toggleEditModal();
    handleEditingItem(item);
  };

  const deleteItemHandler = (item: User): void => {
    toggleDeleteModal();
    handleDeletingItem(item);
  };

  const getActionsList = (user: User): any[] => {
    const actions: ActionItem[] = [];
    if (user.isApproved) {
      actions.push(
        {
          type: 'component',
          label: 'Edit',
          link: `/admin/users/${user.id}/edit`,
          icon: (
            <button>
              <span className="px-1 h-full">
                <AiOutlineEdit
                  color="blue"
                  size={18}
                  onClick={() => {
                    editItemHandler(user);
                  }}
                />
              </span>
            </button>
          )
        },
        {
          type: 'component',
          label: 'Delete',
          link: `/admin/users/${user.id}/edit`,
          icon: (
            <button
              onClick={() => {
                deleteItemHandler(user);
              }}
              className="text-gray-50 text-sm text-center rounded-md"
            >
              <span className="px-1 h-full">
                <AiOutlineDelete color="red" size={18} />
              </span>
            </button>
          )
        }
      );
    } else {
      actions.push(
        {
          type: 'component',
          label: 'Approve',
          icon: <ApproveUser id={user.id} />
        },
        {
          type: 'component',
          label: 'Delete',
          link: `/admin/users/${user.id}/edit`,
          icon: (
            <button
              onClick={() => {
                deleteItemHandler(user);
              }}
              className="text-gray-50 text-sm text-center rounded-md"
            >
              <span className="px-1 h-full">
                <AiOutlineDelete color="red" size={18} />
              </span>
            </button>
          )
        }
      );
    }

    return actions;
  };

  return (
    <>
      <div className="w-full p-2 my-2 overflow-auto rounded-md">
        <table className="w-full p-4 border-b-2 border-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 pl-8 text-sm font-semibold text-left tracking-wide">Fullname</th>
              <th className="p-2 text-sm font-semibold text-left tracking-wide">Email</th>
              <th className="p-2 text-sm font-semibold text-left">Role</th>
              <th className="p-2 text-sm font-semibold text-left">Main Admin</th>
              <th className="p-2 text-sm font-semibold text-left">Approved</th>
              <th className="p-2 text-sm font-semibold text-left">Status</th>
              <th className="p-2 pr-8 text-sm font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody className="">
            {users.map((user) => {
              return <ListUserItem key={user.id} item={user} actions={getActionsList(user)} />;
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ListUsers;
